import PropTypes from 'prop-types';
import React from 'react';
import * as Colors from 'material-ui/styles/colors';
import Snackbar from 'material-ui/Snackbar';
import {
  NAV_MENU_HEIGHT,
  NAV_MENU_HEIGHT_EDITOR,
  TOP_NAV_HEIGHT,
  LEFT_MENU_WIDTH,
} from './consts';

import {
  Header,
  Sidebar,
  ImagesContent,
  MultiItemStatusBarWrapper,
} from './components';

import {
  EditInfoImageDialogRouteConnect,
  DeleteImageDialogRouteConnect,
  NewFolderDialogRouteConnect,
  DeleteFolderDialogRouteConnect,
  RenameFolderDialogRouteConnect,
} from './dialogs';


const getStyles = ({ integrated }) => ({
  main: {
    overflow: 'hidden',
    position: 'relative',
  },
  box: {
    height: integrated ?
      `calc(100% - ${NAV_MENU_HEIGHT_EDITOR}px)` :
      `calc(100vh - ${NAV_MENU_HEIGHT + TOP_NAV_HEIGHT}px)`,
    overflow: 'hidden',
    display: 'flex',
    background: Colors.grey200,
  },
});

export default class ImageManager extends React.Component {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.context.imageUtils.init();
  }

  render() {
    const { style, className, integrated, currentFolder, resourceType,
            type, uploadImagesDirectToEditor, openIntegratedUploadFromUrlDialog,
            snackbarData, closeSnackbar } = this.props;
    const styles = getStyles({ integrated });
    return (
      <div
        className={`${className ? className : ''}`}
        style={{ ...style, ...styles.main }}
      >
        <Header
          currentFolder={currentFolder}
          resourceType={resourceType}
          integrated={integrated}
          type={type}
          uploadImagesDirectToEditor={uploadImagesDirectToEditor}
          openIntegratedUploadFromUrlDialog={openIntegratedUploadFromUrlDialog}
        />
        <div style={styles.box}>
          <Sidebar currentFolder={currentFolder} resourceType={resourceType} integrated={integrated} />
          <ImagesContent
            currentFolder={currentFolder}
            resourceType={resourceType}
            integrated={integrated}
            type={type}
          />
        </div>
        <MultiItemStatusBarWrapper integrated={integrated}/>
        {
          !integrated ? [
            <EditInfoImageDialogRouteConnect
              key="EditInfoImageDialog"
              integrated={false}
            />,
            <NewFolderDialogRouteConnect
              key="NewFolderDialog"
              integrated={false}
            />,
            <DeleteImageDialogRouteConnect
              key="DeleteImageDialog"
              currentFolder={currentFolder}
              integrated={false}
            />,
            <DeleteFolderDialogRouteConnect
              key="DeleteFolderDialog"
              resourceType={resourceType}
              currentFolder={currentFolder}
              integrated={false}
            />,
            <RenameFolderDialogRouteConnect
              key="RenameFolderDialog"
              currentFolder={currentFolder}
              integrated={false}
            />,
          ] : null
        }
        <Snackbar
          open={snackbarData.open}
          message={snackbarData.message}
          action={snackbarData.action}
          onActionClick={snackbarData.actionFunc}
          autoHideDuration={3000}
          onRequestClose={this.props.closeSnackbar}
        />
      </div>
    );
  }
}

ImageManager.defaultProps = {
  integrated: false,
};

ImageManager.propTypes = {
  integrated: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  currentFolder: PropTypes.string,
  forceImagesUpload: PropTypes.func,
};